import {request} from './request'

export function getdetail(id){
  return request({
    method: "GET",
    url:'api/vrdetail/',
    params:{
      id
    }
  })
}

export function getdownurl(id,index){
  return request({
    method: "GET",
    url:'api/downurl/',
    params:{
      id,
      index
    }
  })
}

export function getlogin(){
  return request({
    method: "GET",
    url:'api/islogin/',
  })
}

export function urlinfo(id){
  return request({
    method: "GET",
    url:'api/urlinfo/',
    params:{
      id
    }
  })
}
